(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  // Shopify's legacy ?page= parameter returns only that server page, while this
  // catalogue paginates its complete set in-browser. Canonicalize old links once.
  const ansterCatalogUrl = new URL(window.location.href);
  if (ansterCatalogUrl.searchParams.has('page')) {
    ansterCatalogUrl.searchParams.delete('page');
    window.location.replace(ansterCatalogUrl.toString());
  }

  } catch(e) { console.error(e); }
})();
})();
